import { T } from "./exports";
import { buildLiveUrl } from "./UrlBuilder";

export function LiveUrlPreview({ baseUrl, params = [], allInputVars = [] }) {
  const preview = buildLiveUrl(baseUrl, params, allInputVars);
  if (!preview) return null;

  // Colorise the URL: base = white, ? = yellow, key = blue, = muted, value = green, & = yellow
  const parts = [];
  const qIdx = preview.indexOf("?");
  if (qIdx === -1) {
    parts.push(<span key="base" style={{ color: T.text }}>{preview}</span>);
  } else {
    parts.push(<span key="base" style={{ color: T.text }}>{preview.slice(0, qIdx)}</span>);
    parts.push(<span key="q" style={{ color: T.yellow }}>?</span>);
    const qs = preview.slice(qIdx + 1);
    const pairs = qs.split("&");
    pairs.forEach((pair, i) => {
      const eqIdx = pair.indexOf("=");
      const k = eqIdx === -1 ? pair : pair.slice(0, eqIdx);
      const v = eqIdx === -1 ? "" : pair.slice(eqIdx + 1);
      if (i > 0) parts.push(<span key={`amp${i}`} style={{ color: T.yellow }}>&amp;</span>);
      parts.push(<span key={`k${i}`} style={{ color: T.blueLt }}>{decodeURIComponent(k)}</span>);
      parts.push(<span key={`eq${i}`} style={{ color: T.textMute }}>=</span>);
      // detect template var like ${varName}
      const decoded = decodeURIComponent(v);
      if (decoded.startsWith("${") && decoded.endsWith("}")) {
        parts.push(<span key={`v${i}`} style={{ color: T.blue }}>{decoded}</span>);
      } else {
        parts.push(<span key={`v${i}`} style={{ color: T.green }}>{decoded}</span>);
      }
    });
  }

  return (
    <div style={{ background: T.bg, border: `1px solid ${T.border}`, borderRadius: 3, padding: "5px 7px", marginBottom: 5, marginTop: 2 }}>
      <div style={{ fontSize: 7, color: T.textMute, textTransform: "uppercase", letterSpacing: "0.07em", marginBottom: 3 }}>Live URL Preview</div>
      <div style={{ fontSize: 9, fontFamily: "monospace", wordBreak: "break-all", lineHeight: 1.6 }}>
        {parts}
      </div>
    </div>
  );
}